export const dnldCamp = (builder) => ({
    dnldCamp: builder.mutation({
        query: ({  search, loggedin_user_id, user_type_id, campaignType, startDate, endDate }) => {
            return {
                url: '/downloadCampaignSummary',
                method: 'GET',
                params: {  search, loggedin_user_id, user_type_id, campaignType, startDate, endDate  },
                headers: {
                    'Content-Type':  'text/csv', 
                },
                responseHandler: (response) => response.blob(),
            };
        },
    }),
});